import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ShowBlog.css';

function ShowBlog() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch blog data from the backend API
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`https://b.centrexmarineservices.com/Api/View.php?id=${id}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 'success') {
          setBlog(data.data);
          setError(null);
        } else {
          setError(data.message || 'Failed to fetch blog');
          setBlog(null);
        }
      } catch (err) {
        console.error('Error fetching blog:', err);
        setError('Failed to fetch blog. Please try again later.');
        setBlog(null);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      fetchBlog();
    }
  }, [id]);

  // Format date for display
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Show loading state
  if (isLoading) {
    return (
      <div className="blog-loading">
        <div className="loading-spinner"></div>
        <h2>Loading blog...</h2>
      </div>
    );
  }

  // Show error state
  if (error || !blog) {
    return (
      <div className="blog-not-found">
        <h2>{error || 'Blog not found'}</h2>
        <Link to="/blog" className="back-to-blog-btn">Back to Blogs</Link>
      </div>
    );
  }

  return (
    <div className="show-blog-container">
      {/* Hero section with blog image */}
      <div 
        className="show-blog-hero" 
        style={{ 
          backgroundImage: blog.image_path ? 
            `url(${blog.image_path})` : 
            'url(/Pics/placeholder-image.jpg)' 
        }}
      >
        <div className="show-blog-overlay">
          <h1>{blog.title}</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Blog content section */}
      <div className="show-blog-content-wrapper">
        <div className="show-blog-meta">
          <span className="show-blog-date">{formatDate(blog.date_published)}</span>
          <Link to="/blog" className="back-to-blog-btn">Back to Blogs</Link>
        </div>
        
        {/* Render HTML content safely using dangerouslySetInnerHTML */}
        <div 
          className="show-blog-content"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />
      </div>
    </div>
  );
}

export default ShowBlog;
